import React, { memo, useCallback, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OrganisationLayout from "../layout/OrganisationLayout";
import RegisterChart from "../../Components/common/RegisterChart";
import ActivityChart from "../../Components/common/ActivityChart";
import CustomCarousel from "../../Components/common/CustomCarousel";
import { dropdownGroupsDashboard } from "../../Constant/ConstantData";

const FilterIcon = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.75 4.08342C1.75 2.95583 2.66408 2.04175 3.79167 2.04175C4.91925 2.04175 5.83333 2.95583 5.83333 4.08342C5.83333 5.211 4.91925 6.12508 3.79167 6.12508C2.66408 6.12508 1.75 5.211 1.75 4.08342ZM11.6667 4.66675H7V3.50008H11.6667V4.66675ZM8.16667 9.91675C8.16667 8.78917 9.08075 7.87508 10.2083 7.87508C11.3359 7.87508 12.25 8.78917 12.25 9.91675C12.25 11.0443 11.3359 11.9584 10.2083 11.9584C9.08075 11.9584 8.16667 11.0443 8.16667 9.91675ZM7 9.33342V10.5001H2.33333V9.33342H7Z"
      fill="#2B3674"
    />
  </svg>
));

const NoDataMessage = memo(() => (
  <Container fluid>
    <div
      className="position-relative"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "317px",
      }}
    >
      <p className="data-not-found-cmn">
        We couldn&apos;t find any activity for the selected date range. Try changing
        your filters and check again.
      </p>
    </div>
  </Container>
));

const fallbackThumb = require("../../Assets/Images/clogo.png");

const staticRegisterData = {
  Learners: [
    { date: "2026-03-16", year7: 12, year8: 8, year9: 5, year10: 3 },
    { date: "2026-03-23", year7: 10, year8: 6, year9: 4, year10: 2 },
    { date: "2026-03-30", year7: 9, year8: 7, year9: 6, year10: 3 },
    { date: "2026-04-06", year7: 8, year8: 7, year9: 5, year10: 4 },
    { date: "2026-04-13", year7: 11, year8: 9, year9: 6, year10: 3 },
  ],
  Parents: [
    { date: "2026-03-16", parent: 7 },
    { date: "2026-03-23", parent: 5 },
    { date: "2026-03-30", parent: 4 },
    { date: "2026-04-06", parent: 6 },
    { date: "2026-04-13", parent: 8 },
  ],
};

const staticCategoryData = {
  Learners: [
    { title: "Digital Wellbeing", views: 412, image: fallbackThumb },
    { title: "Growing Up", views: 364, image: fallbackThumb },
    { title: "Keeping Safe", views: 297, image: fallbackThumb },
    { title: "Money Matters", views: 214, image: fallbackThumb },
  ],
  Parents: [
    { title: "Your Future", views: 189, image: fallbackThumb },
    { title: "Your Friends", views: 174, image: fallbackThumb },
    { title: "Rights and Responsibility", views: 152, image: fallbackThumb },
    { title: "Risks", views: 118, image: fallbackThumb },
  ],
};

const staticActivityData = {
  Learners: [
    { year: "7", activeHours: 2.4 },
    { year: "8", activeHours: 1.8 },
    { year: "9", activeHours: 1.4 },
    { year: "10", activeHours: 1.1 },
  ],
  Parents: [
    { year: "7", activeHours: 1.2 },
    { year: "8", activeHours: 0.9 },
    { year: "9", activeHours: 0.8 },
    { year: "10", activeHours: 0.6 },
  ],
};

const staticTrendingTags = {
  Learners: [
    { _id: "1", title: "online-safety" },
    { _id: "2", title: "body-image" },
    { _id: "3", title: "healthy-relationships" },
    { _id: "4", title: "money" },
    { _id: "5", title: "future" },
    { _id: "6", title: "revision" },
    { _id: "7", title: "consent" },
    { _id: "8", title: "self-esteem" },
  ],
  Parents: [
    { _id: "9", title: "supporting-teens" },
    { _id: "10", title: "device-boundaries" },
    { _id: "11", title: "healthy-conversations" },
    { _id: "12", title: "friendships" },
  ],
};

const staticVideoData = {
  Learners: [
    {
      _id: "org-video-1",
      category: "cat-1",
      cover_url: fallbackThumb,
      title: "Managing Online Pressure",
      views: 412,
      likes: 92,
      saves: 38,
    },
    {
      _id: "org-video-2",
      category: "cat-2",
      cover_url: fallbackThumb,
      title: "Body Confidence",
      views: 365,
      likes: 88,
      saves: 25,
    },
    {
      _id: "org-video-3",
      category: "cat-3",
      cover_url: fallbackThumb,
      title: "Safer Messaging",
      views: 287,
      likes: 74,
      saves: 21,
    },
    {
      _id: "org-video-4",
      category: "cat-4",
      cover_url: fallbackThumb,
      title: "Making Good Choices",
      views: 233,
      likes: 61,
      saves: 14,
    },
  ],
  Parents: [
    {
      _id: "org-video-5",
      category: "cat-5",
      cover_url: fallbackThumb,
      title: "Supporting Healthy Boundaries",
      views: 140,
      likes: 40,
      saves: 12,
    },
    {
      _id: "org-video-6",
      category: "cat-6",
      cover_url: fallbackThumb,
      title: "Talking About Online Safety",
      views: 128,
      likes: 35,
      saves: 10,
    },
    {
      _id: "org-video-7",
      category: "cat-7",
      cover_url: fallbackThumb,
      title: "Helping With Exam Stress",
      views: 111,
      likes: 27,
      saves: 8,
    },
    {
      _id: "org-video-8",
      category: "cat-8",
      cover_url: fallbackThumb,
      title: "Starting Better Conversations",
      views: 95,
      likes: 20,
      saves: 6,
    },
  ],
  Staff: [
    {
      _id: "org-video-9",
      category: "cat-9",
      cover_url: fallbackThumb,
      title: "Managing Online Pressure",
      categoryTitle: "Digital Wellbeing",
      group: [3, 4],
    },
    {
      _id: "org-video-10",
      category: "cat-10",
      cover_url: fallbackThumb,
      title: "Healthy Relationships",
      categoryTitle: "Growing Up",
      group: [3],
    },
    {
      _id: "org-video-11",
      category: "cat-11",
      cover_url: fallbackThumb,
      title: "Safer Messaging",
      categoryTitle: "Keeping Safe",
      group: [2, 3],
    },
    {
      _id: "org-video-12",
      category: "cat-12",
      cover_url: fallbackThumb,
      title: "Money Confidence",
      categoryTitle: "Money Matters",
      group: [4],
    },
  ],
};

const staticRecentClasses = [
  {
    _id: "class-1",
    name: "Year 7 North",
    year: 7,
    ownerName: "Northgate College",
    studentsCount: 28,
    collectionsCount: 6,
  },
  {
    _id: "class-2",
    name: "Year 8 East",
    year: 8,
    ownerName: "Riverside School",
    studentsCount: 31,
    collectionsCount: 4,
  },
  {
    _id: "class-3",
    name: "Year 9 West",
    year: 9,
    ownerName: "Elmwood Academy",
    studentsCount: 25,
    collectionsCount: 5,
  },
  {
    _id: "class-4",
    name: "Year 10 Central",
    year: 10,
    ownerName: "Westbridge Campus",
    studentsCount: 22,
    collectionsCount: 3,
  },
];

const staticRecentCollections = [
  {
    _id: "collection-1",
    title: "Staying Safe Online",
    ownedBy: "Harvey James",
    videos: 8,
    shares: 14,
  },
  {
    _id: "collection-2",
    title: "Growing Up Support",
    ownedBy: "Ava Carter",
    videos: 6,
    shares: 11,
  },
  {
    _id: "collection-3",
    title: "Exam Confidence",
    ownedBy: "Tia Morgan",
    videos: 5,
    shares: 9,
  },
];

const staticRecentStaff = [
  {
    _id: "staff-1",
    firstName: "Harvey",
    surName: "James",
    lastLoggedIn: "2026-04-29T10:42:00.000Z",
  },
  {
    _id: "staff-2",
    firstName: "Ava",
    surName: "Carter",
    lastLoggedIn: "2026-04-29T09:25:00.000Z",
  },
  {
    _id: "staff-3",
    firstName: "Tia",
    surName: "Morgan",
    lastLoggedIn: "2026-04-28T16:15:00.000Z",
  },
  {
    _id: "staff-4",
    firstName: "Noah",
    surName: "Bennett",
    lastLoggedIn: "2026-04-27T14:10:00.000Z",
  },
];

const sortClassOptions = {
  updatedAt: "Recently updated",
  createdAt: "Recently created",
  withMostCollections: "Most shared collections",
};

const sortCollectionOptions = {
  shareDate: "Recently shared",
  createdAt: "Recently created",
  updatedAt: "Recently updated",
  mostShared: "Most shared",
};

function OrganisationGroupsDashboard() {
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const organisationGroup = userData?.organisationGroupId;
  const [activeRole, setActiveRole] = useState("Learners");
  const [selectedClassForCategory, setSelectedClassForCategory] = useState("");
  const [sortBy, setSortBy] = useState("views");
  const [sortTags, setSortTags] = useState("views");
  const [sortClasses, setSortClasses] = useState("updatedAt");
  const [sortCollections, setSortCollections] = useState("shareDate");
  const [sortOrder, setSortOrder] = useState("asc");

  const getDefaultDateRange = () => {
    const today = new Date();
    const oneMonthAgo = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate()
    );
    return [oneMonthAgo, today];
  };

  const [selectedFilterDateRange, setSelectedFilterDateRange] = useState(
    getDefaultDateRange
  );

  const learnerAccessible = true;
  const filteredGroups = dropdownGroupsDashboard;

  const handleFilterDateRangeChange = useCallback((dates) => {
    setSelectedFilterDateRange(dates || getDefaultDateRange());
  }, []);

  const getGroupName = useCallback((id) => {
    const groupNames = {
      1: "KS2 Lower",
      2: "KS2 Higher",
      3: "KS3",
      4: "KS4",
      14: "College",
    };
    return groupNames[id] || id;
  }, []);

  const handleSelectForCategory = useCallback(
    (eventKey) => {
      if (typeof eventKey !== "string") {
        setSelectedClassForCategory("");
        return;
      }

      if (eventKey.startsWith("group-")) {
        const groupId = eventKey.replace("group-", "");
        setSelectedClassForCategory(getGroupName(groupId));
      } else if (eventKey.startsWith("year-")) {
        const yearValue = eventKey.replace("year-", "");
        setSelectedClassForCategory(`year-${yearValue}`);
      }
    },
    [getGroupName]
  );

  const isDateFilter =
    selectedFilterDateRange &&
    selectedFilterDateRange.length > 0 &&
    selectedFilterDateRange[0] &&
    selectedFilterDateRange[1];

  const registerData = staticRegisterData[activeRole] || [];
  const categoryData = staticCategoryData[activeRole] || [];
  const activityData = staticActivityData[activeRole] || [];
  const trendingTags = staticTrendingTags[activeRole] || [];
  const videoData =
    staticVideoData[activeRole] ||
    staticVideoData[activeRole === "Staff" ? "Staff" : "Learners"];

  return (
    <OrganisationLayout>
      <Container fluid>
        <Row>
          <Col lg={12} className="d-flex align-items-center">
            <div className="heading-top pe-0 ps-0 w-100">
              <p>Dashboard</p>
              <div className="back-page-title">
                <h2 style={{ fontSize: "1.5rem" }}>
                  {organisationGroup?.name || "Statistics"}
                </h2>
              </div>
              <div className="new-filter-tab-sec d-flex justify-content-between align-items-center w-100">
                <div className="new-tabs d-flex gap-2 mt-3">
                  {learnerAccessible && (
                    <button
                      className={`dash1 ${activeRole === "Learners" ? "active" : ""}`}
                      onClick={() => setActiveRole("Learners")}
                    >
                      Learners
                    </button>
                  )}
                  <button
                    className={`dash1 ${activeRole === "Parents" ? "active" : ""}`}
                    onClick={() => setActiveRole("Parents")}
                  >
                    Parents
                  </button>
                  <button
                    className={`dash1 ${activeRole === "Staff" ? "active" : ""}`}
                    onClick={() => setActiveRole("Staff")}
                  >
                    Staff
                  </button>
                </div>
                <div className="new-filter-sec d-flex gap-3">
                  <DatePicker
                    selected={selectedFilterDateRange[0]}
                    onChange={handleFilterDateRangeChange}
                    startDate={selectedFilterDateRange[0]}
                    endDate={selectedFilterDateRange[1]}
                    selectsRange
                    dateFormat="dd/MM/yyyy"
                    showIcon
                    placeholderText="Select Date Range"
                    isClearable
                    className="calendar-filter"
                    wrapperClassName="datepicker-wrapper"
                    customInput={<input style={{ width: "208px" }} />}
                    maxDate={new Date()}
                    minDate={organisationGroup?.createdAt ? new Date(organisationGroup.createdAt) : undefined}
                  />
                  <Dropdown onSelect={handleSelectForCategory}>
                    <Dropdown.Toggle
                      variant=""
                      id="dropdown-basic"
                      className="d-flex align-items-center"
                    >
                      <FilterIcon />
                      <p className="m-0 flex-grow-1">
                        {selectedClassForCategory || "Year Group"}
                      </p>

                      {selectedClassForCategory && (
                        <FaTimes
                          style={{ cursor: "pointer", marginLeft: 8 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectForCategory(null);
                          }}
                          title="Clear filter"
                        />
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {filteredGroups.map((group) => (
                        <React.Fragment key={group.group}>
                          <Dropdown.Item eventKey={`group-${group.group}`}>
                            {group.label}
                          </Dropdown.Item>
                          {group.years.map((year) => (
                            <Dropdown.Item
                              key={year.value}
                              eventKey={`year-${year.value}`}
                            >
                              {year.name}
                            </Dropdown.Item>
                          ))}
                        </React.Fragment>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {activeRole !== "Staff" ? (
          <>
            <Row className="mb-3">
              <Col xxl={7} lg={12} xl={7} className="display-table mt-4">
                <div className="cmn-card-color table-cell">
                  <div className="details-chart">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <h2 className="f-24">
                        {learnerAccessible ? `Number of ${activeRole} Accounts` : "Parents"}
                      </h2>
                    </div>
                    <div className="m-2">
                      <RegisterChart registerData={registerData} userData={userData} />
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={5} lg={12} xl={5} className="mt-4 display-table">
                <div className="cmn-card-color table-cell">
                  <div className="table-box-cmn">
                    <div className="results-sec">
                      <Row>
                        <Col lg={12} className="most-viewed-categories">
                          <div>
                            <h2 className="f-24">Most Viewed Categories</h2>
                            <div className="Review-history mt-3">
                              {categoryData.length > 0 ? (
                                <>
                                  {categoryData.map((ele, index) => (
                                    <Row className="mb-2" key={`${ele.title}-${index}`}>
                                      <Col lg={8}>
                                        <div className="d-flex align-items-center gap-3">
                                          <img src={ele.image || fallbackThumb} alt="" />
                                          <h3>{ele.title}</h3>
                                        </div>
                                      </Col>

                                      <Col className="d-flex align-items-center justify-content-end">
                                        <p>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="12"
                                            viewBox="0 0 18 12"
                                            fill="none"
                                          >
                                            <path
                                              d="M0.328405 5.07509C0.421391 4.96018 0.5212 4.85 0.617859 4.73792C1.87019 3.28616 3.28282 2.03596 4.95665 1.11952C5.92605 0.588744 6.94797 0.21144 8.04075 0.0627858C9.35523 -0.116013 10.6217 0.0958101 11.8502 0.586899C13.3465 1.18502 14.6589 2.08869 15.8295 3.20256C16.4743 3.81612 17.0693 4.48718 17.6628 5.15491C18.1081 5.65603 18.1067 6.31341 17.6921 6.82043C16.5094 8.26679 15.1722 9.5348 13.6004 10.5264C12.5788 11.1709 11.4936 11.6531 10.3068 11.8745C8.85378 12.1456 7.4461 11.97 6.079 11.42C4.45927 10.7684 3.07035 9.74829 1.82024 8.52419C1.294 8.00889 0.803656 7.4532 0.318565 6.89597C0.294028 6.8678 0.271153 6.83811 0.249547 6.80724C-0.115966 6.28515 -0.0717478 5.56964 0.328405 5.07509ZM8.96527 9.99372C11.1136 9.99566 12.8471 8.21568 12.8492 6.00562C12.8513 3.79623 11.1193 2.01122 8.97235 2.01023C6.82384 2.00924 5.08953 3.79021 5.08869 5.99837C5.08786 8.20942 6.81724 9.99174 8.96527 9.99372Z"
                                              fill="#A3AED0"
                                            />
                                            <path
                                              d="M8.96488 8.86177C7.42934 8.86082 6.1855 7.57373 6.18843 5.98888C6.19136 4.42086 7.44391 3.13975 8.97288 3.14097C10.5075 3.14223 11.7531 4.43157 11.7495 6.01516C11.7458 7.58493 10.4959 8.86271 8.96488 8.86177Z"
                                              fill="#A3AED0"
                                            />
                                          </svg>{" "}
                                          {ele.views} Views
                                        </p>
                                      </Col>
                                    </Row>
                                  ))}
                                </>
                              ) : (
                                <NoDataMessage />
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 align-items-stretch">
              <Col xxl={5} lg={5} className="mt-2 display-table">
                <div className="d-flex align-items-center">
                  <div className="activity-card-color table-cell h-100">
                    <div className="results-sec h-100">
                      <Col className="display-table">
                        <div className="cmn-card-color-dashboard table-cell h-100">
                          <h2 className="f-24">User Activity</h2>
                          <div className="total-views-chat">
                            <div className="mt-4">
                              <ActivityChart activityData={activityData} />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center w-100">
                  <div
                    className="table-cell mt-3 w-100"
                    style={{ backgroundColor: "#ffffff66", borderRadius: "16px" }}
                  >
                    <div className="results-sec w-100">
                      <Col className="display-table h-100 w-100 p-2">
                        <div className="dash-drop-ad px-3 py-2">
                          <h2 className="f-24">Trending Tags</h2>
                          {trendingTags.length > 0 && (
                            <Dropdown onSelect={setSortTags}>
                              <Dropdown.Toggle variant="success" id="dropdown-basic">
                                <FilterIcon />
                                <p className="m-0">
                                  {sortTags.charAt(0).toUpperCase() + sortTags.slice(1)}
                                </p>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item eventKey="views" active={sortTags === "views"}>
                                  Views
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="likes" active={sortTags === "likes"}>
                                  Likes
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="saves" active={sortTags === "saves"}>
                                  Saves
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </div>
                      </Col>
                    </div>
                    {trendingTags.length > 0 ? (
                      <Row className="mt-2 mx-auto">
                        {trendingTags.map(({ _id, title }) => (
                          <OverlayTrigger
                            key={_id}
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${_id}`} className="tooltip">
                                Browse {title} Videos
                              </Tooltip>
                            }
                          >
                            <Col
                              lg={3}
                              md={3}
                              sm={4}
                              className="mb-3"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate(`/browse?searchkey=${title}`)}
                              role="button"
                              tabIndex={0}
                              onKeyPress={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  navigate(`/browse?searchkey=${title}`);
                                }
                              }}
                            >
                              <div className="user-activity-card">
                                <div className="user-details mx-2" style={{ flex: 1, minWidth: 0 }}>
                                  <h6
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: "100%",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    #{title}
                                  </h6>
                                </div>
                              </div>
                            </Col>
                          </OverlayTrigger>
                        ))}
                      </Row>
                    ) : (
                      <NoDataMessage />
                    )}
                  </div>
                </div>
              </Col>

              <Col xxl={7} lg={7} className="mt-2 display-table">
                <div className="cmn-card-color table-cell h-100">
                  <div className="table-box-cmn h-100">
                    <div className="results-sec h-100">
                      <Row className="h-100">
                        <Col
                          lg={12}
                          className="d-flex align-items-center justify-content-between h-100"
                        >
                          <Col lg={12} className="display-table h-100">
                            <div className="cmn-card-color-dashboard table-cell h-100">
                              <div className="dash-drop-ad">
                                <h2 className="f-24">Most Popular Videos</h2>

                                <Dropdown onSelect={setSortBy}>
                                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    <FilterIcon />{" "}
                                    <p className="m-0">
                                      {sortBy.charAt(0).toUpperCase() + sortBy.slice(1)}
                                    </p>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item eventKey="views" active={sortBy === "views"}>
                                      Views
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="likes" active={sortBy === "likes"}>
                                      Likes
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="saves" active={sortBy === "saves"}>
                                      Saves
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                              <div className="Review-history mt-3">
                                {videoData.length > 0 ? (
                                  <CustomCarousel videoData={videoData} />
                                ) : (
                                  <NoDataMessage />
                                )}
                              </div>
                            </div>
                          </Col>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className="mb-3">
              <Col xxl={7} lg={12} xl={7} className="display-table mt-4">
                <div className="cmn-card-color table-cell">
                  <div className="recently-active-chart">
                    <div className="recently-main-sec">
                      {isDateFilter ? (
                        <div>
                          <div className="total-class-head">
                            <h2>{staticRecentClasses.length} Active classes during this period</h2>
                          </div>
                        </div>
                      ) : (
                        <div className="total-classes-head">
                          <div className="recently-head">
                            <h2>Recently Active Classes</h2>
                          </div>
                          <div className="total-classes">
                            <div className="total-class-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 72 72">
                                {[8, 26, 44].flatMap((x) =>
                                  [8, 26, 44].map((y) => (
                                    <rect key={`${x}-${y}`} x={x} y={y} width="10" height="10" rx="3" ry="3" fill="#2B3674" />
                                  ))
                                )}
                              </svg>
                            </div>
                            <div className="total-class-head">
                              <h2>{staticRecentClasses.length} classes total</h2>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="new-filter-sec d-flex gap-3">
                        <Dropdown onSelect={setSortClasses}>
                          <Dropdown.Toggle variant="" id="dropdown-basic" aria-label="Sort options">
                            <FilterIcon />{" "}
                            <p className="m-0">
                              {sortClassOptions[sortClasses] || "Sort By"}
                            </p>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item eventKey="updatedAt" active={sortClasses === "updatedAt"}>
                              Recently updated
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="createdAt" active={sortClasses === "createdAt"}>
                              Recently created
                            </Dropdown.Item>
                            <Dropdown.Item
                              eventKey="withMostCollections"
                              active={sortClasses === "withMostCollections"}
                            >
                              Most shared collections
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="recently-card">
                      <Row>
                        <Col lg={12}>
                          <Row>
                            {staticRecentClasses.map((item) => (
                              <Col lg={4} md={6} sm={12} className="mb-3" key={item._id}>
                                <div className="recently-active-card h-100">
                                  <div className="recently-active-head card-body">
                                    <h6
                                      className="card-title"
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "100%",
                                        wordBreak: "break-all",
                                        color: "#2b3674",
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: "26px",
                                        letterSpacing: "-0.02em",
                                      }}
                                      title={item.name}
                                    >
                                      <u>{item.name}</u>
                                    </h6>
                                  </div>
                                  <div className="year-section">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                      <path fill="#2b3674" d="M21.5 16.925v-7.05L11.975 15 1 9 11.975 3 23 9v7.925h-1.5ZM11.975 21l-7.25 -3.975v-5.25l7.25 3.975 7.25 -3.975v5.25L11.975 21Z" strokeWidth="0.5" />
                                    </svg>
                                    <div className="year-desc">
                                      <p>Year {item.year}</p>
                                    </div>
                                  </div>
                                  <div className="owned-section">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                      <path fill="#2b3674" d="M3.5 20c-0.4 0 -0.75 -0.15415 -1.05 -0.4625C2.15 19.22915 2 18.88335 2 18.5V5.5c0 -0.38335 0.15 -0.729165 0.45 -1.0375C2.75 4.154165 3.1 4 3.5 4h7.025l1.5 1.5H20.5c0.38335 0 0.72915 0.15415 1.0375 0.4625 0.30835 0.30835 0.4625 0.65415 0.4625 1.0375v11.5c0 0.38335 -0.15415 0.72915 -0.4625 1.0375 -0.30835 0.30835 -0.65415 0.4625 -1.0375 0.4625H3.5Zm7.475 -3.25h8v-0.475c0 -0.7 -0.35415 -1.27085 -1.0625 -1.7125 -0.70835 -0.44165 -1.6875 -0.6625 -2.9375 -0.6625s-2.22915 0.22085 -2.9375 0.6625c-0.70835 0.44165 -1.0625 1.0125 -1.0625 1.7125v0.475Zm4 -4.35c0.5 0 0.92915 -0.17915 1.2875 -0.5375 0.35835 -0.35835 0.5375 -0.7875 0.5375 -1.2875 0 -0.5 -0.17915 -0.92915 -0.5375 -1.2875 -0.35835 -0.35835 -0.7875 -0.5375 -1.2875 -0.5375 -0.5 0 -0.92915 0.17915 -1.2875 0.5375 -0.35835 0.35835 -0.5375 0.7875 -0.5375 1.2875 0 0.5 0.17915 0.92915 0.5375 1.2875 0.35835 0.35835 0.7875 0.5375 1.2875 0.5375Z" strokeWidth="0.5" />
                                    </svg>
                                    <div className="year-desc">
                                      <p>Owned by <u>{item.ownerName}</u></p>
                                    </div>
                                  </div>
                                  <div className="students-section">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                      <path fill="#2b3674" d="M0.94995 20.0001v-2.35c0 -0.58335 0.15 -1.1125 0.45 -1.5875 0.3 -0.475 0.71667 -0.82915 1.25 -1.0625 1.21667 -0.53335 2.3125 -0.91665 3.2875 -1.15 0.975 -0.23335 1.97915 -0.35 3.0125 -0.35 1.03335 0 2.03335 0.11665 3 0.35 0.96665 0.23335 2.05835 0.61665 3.275 1.15 0.53335 0.23335 0.95415 0.5875 1.2625 1.0625 0.30835 0.475 0.4625 1.00415 0.4625 1.5875v2.35h-16Zm17.5 0v-2.35c0 -1.05 -0.26665 -1.9125 -0.8 -2.5875 -0.53335 -0.675 -1.23335 -1.22085 -2.1 -1.6375 1.15 0.13335 2.23335 0.32915 3.25 0.5875 1.01665 0.25835 1.84165 0.55415 2.475 0.8875 0.55 0.31665 0.98335 0.70835 1.3 1.175 0.31665 0.46665 0.475 0.99165 0.475 1.575v2.35h-4.6Zm-9.5 -8.025c-1.1 0 -2 -0.35 -2.7 -1.05 -0.7 -0.7 -1.05 -1.6 -1.05 -2.7s0.35 -2 1.05 -2.7c0.7 -0.7 1.6 -1.05 2.7 -1.05s2 0.35 2.7 1.05c0.7 0.7 1.05 1.6 1.05 2.7s-0.35 2 -1.05 2.7c-0.7 0.7 -1.6 1.05 -2.7 1.05Zm9 -3.75c0 1.1 -0.35 2 -1.05 2.7 -0.7 0.7 -1.6 1.05 -2.7 1.05 -0.18335 0 -0.3875 -0.0125 -0.6125 -0.0375 -0.225 -0.025 -0.42915 -0.07085 -0.6125 -0.1375 0.4 -0.41665 0.70415 -0.92915 0.9125 -1.5375 0.20835 -0.60835 0.3125 -1.2875 0.3125 -2.0375s-0.10415 -1.4125 -0.3125 -1.9875c-0.20835 -0.575 -0.5125 -1.10415 -0.9125 -1.5875 0.18335 -0.05 0.3875 -0.09167 0.6125 -0.125 0.225 -0.033335 0.42915 -0.05 0.6125 -0.05 1.1 0 2 0.35 2.7 1.05 0.7 0.7 1.05 1.6 1.05 2.7Z" strokeWidth="0.5" />
                                    </svg>
                                    <div className="year-desc">
                                      <p>{item.studentsCount} students</p>
                                    </div>
                                  </div>
                                  <div className="shared-collections">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                      <path fill="#2b3674" d="M4 22.0001v-14.525c0 -0.4125 0.146915 -0.76565 0.44075 -1.0595 0.293665 -0.29365 0.64675 -0.4405 1.05925 -0.4405h9c0.4125 0 0.76565 0.14685 1.0595 0.4405 0.29365 0.29385 0.4405 0.647 0.4405 1.0595v14.525l-6 -2.975 -6 2.975Zm14.5 -3.975v-14.55H7.1v-1.5H18.5c0.4125 0 0.76565 0.14683 1.0595 0.4405 0.29365 0.29383 0.4405 0.647 0.4405 1.0595v14.55h-1.5Z" strokeWidth="0.5" />
                                    </svg>
                                    <div className="year-desc">
                                      <p>{item.collectionsCount} shared collections</p>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xxl={5} lg={12} xl={5} className="mt-4 display-table">
                <div className="cmn-card-color table-cell" style={{ position: "relative", minHeight: "600px" }}>
                  <div className="recently-active-chart">
                    <div className="recently-main-sec">
                      {isDateFilter ? (
                        <div>
                          <div className="total-class-head">
                            <h2>{staticRecentCollections.length} Active Collections during this period</h2>
                          </div>
                        </div>
                      ) : (
                        <div className="total-classes-head">
                          <div className="recently-head">
                            <h2>Recently Shared Collections</h2>
                          </div>
                          <div className="total-classes">
                            <div className="total-class-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 72 72">
                                {[8, 26, 44].flatMap((x) =>
                                  [8, 26, 44].map((y) => (
                                    <rect key={`${x}-${y}`} x={x} y={y} width="10" height="10" rx="3" ry="3" fill="#2B3674" />
                                  ))
                                )}
                              </svg>
                            </div>
                            <div className="total-class-head me-3">
                              <h2 className="text-nowrap">{staticRecentCollections.length} collections</h2>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="new-filter-sec d-flex gap-3">
                        <Dropdown onSelect={setSortCollections}>
                          <Dropdown.Toggle variant="" id="dropdown-basic" aria-label="Sort options">
                            <FilterIcon />{" "}
                            <p className="m-0">
                              {sortCollectionOptions[sortCollections] || "Sort By"}
                            </p>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item eventKey="shareDate" active={sortCollections === "shareDate"}>
                              Recently shared
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="createdAt" active={sortCollections === "createdAt"}>
                              Recently created
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="updatedAt" active={sortCollections === "updatedAt"}>
                              Recently updated
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="mostShared" active={sortCollections === "mostShared"}>
                              Most shared
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="recently-card">
                      <Row>
                        {staticRecentCollections.map((item) => (
                          <Col lg={12} className="mb-3" key={item._id}>
                            <div className="recently-active-card">
                              <div className="recently-active-head card-body">
                                <h6 className="card-title" style={{ color: "#2b3674", fontWeight: 600 }}>
                                  <u>{item.title}</u>
                                </h6>
                              </div>
                              <div className="owned-section">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                  <path fill="#2b3674" d="M3.5 20c-0.4 0 -0.75 -0.15415 -1.05 -0.4625C2.15 19.22915 2 18.88335 2 18.5V5.5c0 -0.38335 0.15 -0.729165 0.45 -1.0375C2.75 4.154165 3.1 4 3.5 4h7.025l1.5 1.5H20.5c0.38335 0 0.72915 0.15415 1.0375 0.4625 0.30835 0.30835 0.4625 0.65415 0.4625 1.0375v11.5c0 0.38335 -0.15415 0.72915 -0.4625 1.0375 -0.30835 0.30835 -0.65415 0.4625 -1.0375 0.4625H3.5Zm7.475 -3.25h8v-0.475c0 -0.7 -0.35415 -1.27085 -1.0625 -1.7125 -0.70835 -0.44165 -1.6875 -0.6625 -2.9375 -0.6625s-2.22915 0.22085 -2.9375 0.6625c-0.70835 0.44165 -1.0625 1.0125 -1.0625 1.7125v0.475Zm4 -4.35c0.5 0 0.92915 -0.17915 1.2875 -0.5375 0.35835 -0.35835 0.5375 -0.7875 0.5375 -1.2875 0 -0.5 -0.17915 -0.92915 -0.5375 -1.2875 -0.35835 -0.35835 -0.7875 -0.5375 -1.2875 -0.5375 -0.5 0 -0.92915 0.17915 -1.2875 0.5375 -0.35835 0.35835 -0.5375 0.7875 -0.5375 1.2875 0 0.5 0.17915 0.92915 0.5375 1.2875 0.35835 0.35835 0.7875 0.5375 1.2875 0.5375Z" strokeWidth="0.5" />
                                </svg>
                                <div className="year-desc">
                                  <p>Owned by <u>{item.ownedBy}</u></p>
                                </div>
                              </div>
                              <div className="students-section">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                  <path fill="#2b3674" d="M0.94995 20.0001v-2.35c0 -0.58335 0.15 -1.1125 0.45 -1.5875 0.3 -0.475 0.71667 -0.82915 1.25 -1.0625 1.21667 -0.53335 2.3125 -0.91665 3.2875 -1.15 0.975 -0.23335 1.97915 -0.35 3.0125 -0.35 1.03335 0 2.03335 0.11665 3 0.35 0.96665 0.23335 2.05835 0.61665 3.275 1.15 0.53335 0.23335 0.95415 0.5875 1.2625 1.0625 0.30835 0.475 0.4625 1.00415 0.4625 1.5875v2.35h-16Zm17.5 0v-2.35c0 -1.05 -0.26665 -1.9125 -0.8 -2.5875 -0.53335 -0.675 -1.23335 -1.22085 -2.1 -1.6375 1.15 0.13335 2.23335 0.32915 3.25 0.5875 1.01665 0.25835 1.84165 0.55415 2.475 0.8875 0.55 0.31665 0.98335 0.70835 1.3 1.175 0.31665 0.46665 0.475 0.99165 0.475 1.575v2.35h-4.6Zm-9.5 -8.025c-1.1 0 -2 -0.35 -2.7 -1.05 -0.7 -0.7 -1.05 -1.6 -1.05 -2.7s0.35 -2 1.05 -2.7c0.7 -0.7 1.6 -1.05 2.7 -1.05s2 0.35 2.7 1.05c0.7 0.7 1.05 1.6 1.05 2.7s-0.35 2 -1.05 2.7c-0.7 0.7 -1.6 1.05 -2.7 1.05Zm9 -3.75c0 1.1 -0.35 2 -1.05 2.7 -0.7 0.7 -1.6 1.05 -2.7 1.05 -0.18335 0 -0.3875 -0.0125 -0.6125 -0.0375 -0.225 -0.025 -0.42915 -0.07085 -0.6125 -0.1375 0.4 -0.41665 0.70415 -0.92915 0.9125 -1.5375 0.20835 -0.60835 0.3125 -1.2875 0.3125 -2.0375s-0.10415 -1.4125 -0.3125 -1.9875c-0.20835 -0.575 -0.5125 -1.10415 -0.9125 -1.5875 0.18335 -0.05 0.3875 -0.09167 0.6125 -0.125 0.225 -0.033335 0.42915 -0.05 0.6125 -0.05 1.1 0 2 0.35 2.7 1.05 0.7 0.7 1.05 1.6 1.05 2.7Z" strokeWidth="0.5" />
                                </svg>
                                <div className="year-desc">
                                  <p>{item.videos} videos</p>
                                </div>
                              </div>
                              <div className="shared-collections">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                  <path fill="#2b3674" d="M4 22.0001v-14.525c0 -0.4125 0.146915 -0.76565 0.44075 -1.0595 0.293665 -0.29365 0.64675 -0.4405 1.05925 -0.4405h9c0.4125 0 0.76565 0.14685 1.0595 0.4405 0.29365 0.29385 0.4405 0.647 0.4405 1.0595v14.525l-6 -2.975 -6 2.975Zm14.5 -3.975v-14.55H7.1v-1.5H18.5c0.4125 0 0.76565 0.14683 1.0595 0.4405 0.29365 0.29383 0.4405 0.647 0.4405 1.0595v14.55h-1.5Z" strokeWidth="0.5" />
                                </svg>
                                <div className="year-desc">
                                  <p>{item.shares} shares</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 align-items-stretch">
              <Col xxl={5} lg={5} className="mt-2 display-table">
                <div className="activity-card-color table-cell">
                  <div className="table-box-cmn">
                    <div className="results-sec">
                      <div className="recently-active-chart">
                        <div className="recently-main-sec">
                          <div className="total-classes-head">
                            <div className="recently-head">
                              <h2>Recently Active Staff</h2>
                            </div>
                            <div className="total-classes">
                              <div className="total-class-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 72 72">
                                  {[8, 26, 44].flatMap((x) =>
                                    [8, 26, 44].map((y) => (
                                      <rect key={`${x}-${y}`} x={x} y={y} width="10" height="10" rx="3" ry="3" fill="#2B3674" />
                                    ))
                                  )}
                                </svg>
                              </div>
                              <div className="total-class-head">
                                <h2>{staticRecentStaff.length} teachers total</h2>
                              </div>
                              <div className="total-class-head ms-2" style={{ cursor: "pointer" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" onClick={() => setSortOrder("asc")}>
                                  <path d="M12 5l0 14M5 12l7-7 7 7" fill="none" stroke={sortOrder === "asc" ? "#d200a5" : "#2E3472"} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" className="ms-1" onClick={() => setSortOrder("desc")}>
                                  <path d="M12 19l0-14M5 12l7 7 7-7" fill="none" stroke={sortOrder === "desc" ? "#d200a5" : "#2E3472"} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="recently-card">
                            <Row className="mt-4">
                              {staticRecentStaff.map((item) => (
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  className="mb-3"
                                  key={item._id}
                                  onClick={() => navigate(`/organisations/teacher-detail/${item._id}`)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="user-activity-card">
                                    <div className="user-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="8" r="4" fill="#2b3674" />
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#2b3674" strokeWidth="2" fill="none" />
                                      </svg>
                                    </div>
                                    <div className="user-details" style={{ flex: 1, minWidth: 0 }}>
                                      <h6
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          maxWidth: "100%",
                                          wordBreak: "break-all",
                                        }}
                                      >
                                        {`${item.firstName} ${item.surName}`}
                                      </h6>
                                      <p className="last-active">
                                        {new Date(item.lastLoggedIn).toLocaleDateString()}{" "}
                                        {new Date(item.lastLoggedIn).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xxl={7} lg={7} className="mt-2 display-table">
                <div className="cmn-card-color table-cell">
                  <div className="table-box-cmn">
                    <div className="results-sec">
                      <Row>
                        <Col lg={12} className="display-table">
                          <div className="cmn-card-color-dashboard table-cell pt-0">
                            <div className="dash-drop-ad">
                              <h2 className="f-24">Most Shared Videos</h2>
                            </div>
                            <div className="Review-history mt-3">
                              <CustomCarousel videoData={staticVideoData.Staff} type="Staff" />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </OrganisationLayout>
  );
}

export default memo(OrganisationGroupsDashboard);
